// extracted by mini-css-extract-plugin
export default {"root":"TrustBadgesPanel_root__mAnfQ","loading":"TrustBadgesPanel_loading__zX0vb","seals":"TrustBadgesPanel_seals__KawtM","closeButton":"TrustBadgesPanel_closeButton__V7R-y"};